// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdown-toggle[data-v-a71d6a4c]:after{content:normal}.content__main[data-v-a71d6a4c]{align-items:center;display:flex;flex-direction:column;height:40vh;justify-content:center;margin:0 10px;padding:10px 0;text-align:center;width:100%;width:80%}.content__main h1[data-v-a71d6a4c]{color:#ff0d00;font-size:30px;font-weight:700}.content__main div[data-v-a71d6a4c]{color:#333;max-width:650px;min-height:35px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
